import { DocTiles } from "../files/doc-tiles";
import { useState, useEffect, useContext } from "react";
import { useMsal, } from '@azure/msal-react';
import DocsAPI from "../../api/docs/docs-api-factory";
import { arrayAny } from "../../utils/arrayUtils";
import { TenantContext } from "../../pages/tenants/tenant-detail";

export const TenantsDocumentsTab = () => {

    const tabName = "Documents";

    const { tenant, setTenant, validationErrors, setValidationErrors } = useContext(TenantContext);

    const { instance, inProgress, accounts } = useMsal();
    const [data, setData] = useState(null);
    const [fetchDocTypesInProgress, setFetchDocTypesInProgress] = useState(false);
    const [shouldFetch, setShouldFetch] = useState(true);
    const [showDelete, setShowDelete] = useState(false);

    useEffect(() => {

        if (shouldFetch && !fetchDocTypesInProgress) {
            setFetchDocTypesInProgress(true);

            const api = new DocsAPI(instance, inProgress, accounts);

            api.getAll(['tenant']) // Fetch doc types related to this screen
                .then(data => setData(data))
                .catch(error => {
                    console.error("An error occurred fetching data.", error)
                })
                .finally(() => {
                    setFetchDocTypesInProgress(false);
                    setShouldFetch(false);
                });
        }
    });

    const showButtons = () => {
        return tenant && arrayAny(tenant.documents);
    };

    return (
        <div className="tab-content panel p-3 rounded">
            <div className="tab-pane fade active show" id="default-tab-5">
                <div className="d-flex">
                    <h3 className="mt-10px">{tabName}</h3>
                    {showButtons() &&
                        <div className="mt-10px ms-auto btn-group">
                            <button className="btn btn-success btn-rounded px-4 rounded-pill btn-red" onClick={() => setShowDelete(!showDelete)}>
                                <i className="fas fa-fw fa-lg me-10px fa-trash-can ms-n2 "></i>Delete Documents
                            </button>
                        </div>}
                </div>
                <DocTiles
                    docs={tenant.documents}
                    docTypes={data}
                    documentHolder={tenant}
                    showDelete={showDelete}
                    containerName={tenant.company.name}
                    contextType="tenant"
                />
            </div>
        </div>
    );
}